const parseTimeoutSeconds = (envValue, fallback) => {
  const n = parseInt(String(envValue ?? '').trim(), 10)
  return Number.isFinite(n) && n > 0 ? n : fallback
}

/** Producción por defecto; en dev acortar vía `.env.local` (requiere reiniciar `npm start`). */
export const SAVER_TIMEOUT_SECONDS = parseTimeoutSeconds(
  process.env.REACT_APP_SAVER_TIMEOUT_SECONDS,
  60
)
export const IDLE_TIMEOUT_SECONDS = parseTimeoutSeconds(
  process.env.REACT_APP_IDLE_TIMEOUT_SECONDS,
  300
)
export const IDLE_PROMPT_SECONDS = parseTimeoutSeconds(
  process.env.REACT_APP_IDLE_PROMPT_SECONDS,
  20
)
export const IDLE_DONE_TIMEOUT_SECONDS = parseTimeoutSeconds(
  process.env.REACT_APP_IDLE_DONE_TIMEOUT_SECONDS,
  600
)
export const IDLE_DONE_PROMPT_SECONDS = parseTimeoutSeconds(
  process.env.REACT_APP_IDLE_DONE_PROMPT_SECONDS,
  6
)

/** App.onDoneIdle → BookingConfirmed.exit (evita doble timer UI + idleDone). */
export const KIOSK_CONFIRMED_IDLE_DONE_EVENT = 'kiosk:confirmed-idle-done'

/** Tras compra exitosa: segundos hasta volver al dashboard (temporizador global + aviso). */
const _confirmedReturn = parseInt(String(process.env.REACT_APP_CONFIRMED_RETURN_SECONDS ?? '90').trim(), 10)
export const BOOKING_CONFIRMED_RETURN_SECONDS =
  Number.isFinite(_confirmedReturn) && _confirmedReturn > 0 ? _confirmedReturn : 90

export const BASE_URL = ''
export const RESERVATION_CODE_MIN_SIZE = 12
export const RESERVATION_CODE_MAX_SIZE = 12
export const RESERVATION_LIMIT_TIME = 300

export const RELOAD_TOUCH_COUNT = 3
export const LOADING_TIMEOUT = 90000

export const DEBUG_TIMERS = process.env.REACT_APP_DEBUG_TIMERS
export const DEBUG_PINPAD = process.env.REACT_APP_DEBUG_PINPAD

/** QA: cobro + confirm sin pinpad/API. Solo dev: `.env.local` → `REACT_APP_MOCK_BOOKING_PAYMENT=1` */
export const MOCK_BOOKING_PAYMENT =
  process.env.NODE_ENV !== 'production' &&
  String(process.env.REACT_APP_MOCK_BOOKING_PAYMENT || '').trim() === '1'

/** Montos de prueba por nombre en BookingReviewOrder. Opt-in: `REACT_APP_MAGIC_VALUE_ENABLED=1` (dev o build prod). */
export const MAGIC_VALUE_ENABLED =
  String(process.env.REACT_APP_MAGIC_VALUE_ENABLED || '').trim() === '1'
export const DEBUG_SEND_CONSULTA = process.env.REACT_APP_DEBUG_SEND_CONSULTA
export const VER_APP = process.env.REACT_APP_VER_APP
/** Electron login: botón dev → DevTools. Solo con `=1` y `electronAPI` disponible. */
export const ENABLE_LOGIN_DEVTOOLS =
  String(process.env.REACT_APP_ENABLE_LOGIN_DEVTOOLS || '').trim() === '1'
/** Flight Recorder: panel + gesto + `?fr=1` / localStorage. Solo con `=1`. */
export const ENABLE_FLIGHT_RECORDER =
  String(process.env.REACT_APP_ENABLE_FLIGHT_RECORDER || '').trim() === '1'

const categoria = {
  "Adulto": 1,
  "Menor": 2,
  "Senectud": 3,
  "Estudiante": 4,
  "Profesor": 5,
  "Mascota": 6,
}

export class TicketType {
  static Adulto = 1
  static Menor = 2
  static Senectud = 3
  static Estudiante = 4
  static Profesor = 5
  static Mascota = 6
  static Preferente = 368
  

  static label(id) {
    if (typeof id !== 'number') {
      if (typeof id === 'string') {
        id = id.charAt(0).toUpperCase() + id.slice(1).toLowerCase()
      }
      id = categoria[id]
    }
    switch (id) {
      case this.Adulto: return 'Adulto'
      case this.Menor: return 'Menor'
      case this.Senectud: return 'Senectud'
      case this.Estudiante: return 'Estudiante'
      case this.Profesor: return 'Profesor'
      case this.Mascota: return 'Mascota'
      case this.Preferente: return 'Preferente'
      default: return 'Desconocido'
    }
  }

  static icon(id) {
    if (typeof id !== 'number') {
      if (typeof id === 'string') {
        id = id.charAt(0).toUpperCase() + id.slice(1).toLowerCase()
      }
      id = categoria[id]
    }
    switch (id) {
      case this.Adulto: return 'user-tie'
      case this.Menor: return 'child'
      case this.Senectud: return 'person-cane'
      case this.Estudiante: return 'user-graduate'
      case this.Profesor: return 'chalkboard-user'
      case this.Mascota: return 'paw'
      case this.Preferente: return 'wheelchair'
      default: return 'Desconocido'
    }
  }
}
